module.exports = __webpack_public_path__ + "img/todaystore-temporary-halt.0c122ec5.png";